import { useFieldContext } from "../hooks/surveyResponseFormHooks";
import { useTranslation } from "react-i18next";
import { CharacterCount } from "@pulse/components/CharacterCount";
import { getFirstErrorMessage } from "@pulse/utils/formErrors";

function TextAnswerInput({ maxCharacters }: { maxCharacters?: number }) {
    const field = useFieldContext();
    const { t } = useTranslation();
    const value = typeof field.state.value === "string" ? field.state.value : "";
    const errorMessage = getFirstErrorMessage(field.state.meta.errors);
    const isAtMaxLength = maxCharacters !== undefined && value.length >= maxCharacters;
    const hasErrorStyle = Boolean(errorMessage) || isAtMaxLength;

    return (
        <div className="mb-8 flex flex-col gap-1">
            {maxCharacters && (
                <CharacterCount currentLength={value.length} maxLength={maxCharacters} />
            )}
            <textarea
                className={`w-full border rounded-md p-3 min-h-[120px] resize-vertical focus:outline-none focus:ring-2 ${
                    hasErrorStyle
                        ? "border-error ring-2 ring-error focus:ring-error focus:border-error"
                        : "border-gray-300 focus:ring-info focus:border-transparent"
                }`}
                placeholder={t("question.textInput.placeholder")}
                value={value}
                onChange={(e) => field.handleChange(e.target.value)}
                rows={4}
                maxLength={maxCharacters}
                onBlur={field.handleBlur}
            />
            {errorMessage && (
                <div className="text-sm text-error">
                    {t(errorMessage, maxCharacters ? { max: maxCharacters } : {})}
                </div>
            )}
            {!errorMessage && isAtMaxLength && (
                <div className="text-sm">{t("common.maxLengthReached")}</div>
            )}
        </div>
    );
}

export default TextAnswerInput;
